import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Premium%20streetwear%20collection%20display%20with%20sneakers%20and%20clothing%20on%20minimalist%20white%20shelves%2C%20warm%20ambient%20boutique%20lighting%2C%20modern%20Scandinavian%20retail%20interior%2C%20clean%20high-end%20fashion%20store%20atmosphere%2C%20no%20people%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones&width=1600&height=900&seq=hero-v2-2026-a1&orientation=landscape"
          alt="Premium streetwear and sneaker collection displayed in a modern boutique"
          title="Basetao Spreadsheet fashion shopping inspiration"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-2xl">
          <p className="text-sm md:text-base font-medium text-white/80 mb-4 tracking-wide">
            Your Smart Shopping Companion
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            The Ultimate <span className="text-primary-300">Basetao Spreadsheet</span> Guide
          </h1>
          <p className="text-base md:text-lg text-white/75 leading-relaxed mb-8 max-w-xl">
            Discover the best Basetao spreadsheet finds across 14 product categories. Compare products, access exclusive deals, and shop smarter with our complete resource platform.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <Link
              to="/article/basetao-spreadsheet-guide"
              className="px-6 py-3 text-sm font-semibold text-foreground-950 bg-white hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Read Complete Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap"
            >
              Shop Now on Basetao
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}